<ng-container *transloco="let t; prefix: 'navigation'">
  <div class="wrapper">
    @if (userBasicInfo$ | async; as user) {
      <app-language-form />
      @if (isAdmin(user)) {
        <button matButton="text" (click)="whipe()" matTooltip="Удалить весь прогресс">Whipe</button>
      }
      <button matButton="text" (click)="logout()" [matTooltip]="t('buttonLogoutHint')">{{ t("buttonLogoutLabel") }}</button>
    }
  </div>
</ng-container>
